import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { DocumentPicker } from '@shared/components/pickers/DocumentPicker';
import { ReactComponent as IconDocument } from '@svg/icon-document.svg';
import { RelativeWrapper } from '@shared/styledComponents';
import { toBase64 } from '@shared/commonFunctions';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { PdfViewer } from '@shared/components/PdfViewer';
import { Loader } from '@shared/enhancers/withLoader';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { LocalTabContent } from '@styles/CommonStyles';
import { DealsButton } from '@styles/StyledButtons';
import { ILenderEditorTabProps } from '../LenderEditorTabs';
import { IRateCard, requestUpdateRateCard } from './queries';

export const RateCards = ({ lenderId }: ILenderEditorTabProps) => {
  const { data: rateCards, error, isValidating } = useSWR<IRateCard[]>(`/lender-service/lenderdocuments/${lenderId}`);
  const [files, setFile] = useState<File[] | null>();
  const [filePreview, setFilePreview] = useState<string>('');

  const fileContents = rateCards?.[0]?.fileContents || filePreview;

  useEffect(() => {
    setFile([]);
  }, [rateCards]);

  const base64Content = async(file: File) => {
    const result = await toBase64(file);
    return result.split(',')[1];
  };

  const handleOpen = async(files: File[] | null) => {
    setFile(files);

    if (files?.length) {
      const fileBase64Content = await base64Content(files[0]);
      setFilePreview(fileBase64Content);
    } else {
      setFilePreview('');
    }
  };

  const handleSave = async() => {
    if (files?.length) {
      const [file] = files;
      const fileBase64Content = await base64Content(files[0]);

      await requestUpdateRateCard(lenderId, {
        fileName: file.name,
        fileContent: fileBase64Content,
        userId: 0,
      });
      Notistack.infoMessage('File Uploaded');
    }
  };

  return (
    <RelativeWrapper>
      <DealsButton
        size="medium"
        disabled={!files?.length}
        loading={false}
        sx={{ position: 'absolute', right: '3px', top: '-110px' }}
        onClick={handleSave}
      >
        Upload
      </DealsButton>

      <LocalTabContent>
        <DocumentPicker icon={<IconDocument />} files={files as File[]} onChange={handleOpen} />

        {!rateCards && isValidating ? <Loader /> : rateCards && !error ? <PdfViewer fileSource={fileContents} /> : ''}
      </LocalTabContent>
    </RelativeWrapper>
  );
};
